<template>
    <div class="search-wrapper">
        <form @submit.prevent="getSearchResults" class="search-box">
            <div class="form-group m-0">
                <input type="text" class="form-control search-bar" v-model="inputHash" placeholder="Search by hash"/>
                <img @click.prevent="getSearchResults">
            </div>
        </form>
    </div>
    <div v-if="scanDetails">
        <transition name="fade" appear> 
            <ScanDetails
                :scanDetails="scanDetails"
                :isClosed="false"
            />
        </transition>
    </div>




<!--     <div v-if="searchNotFound">
        Nothing found on your hash: {{ inputHash }}
    </div> -->

</template>

<script>
import ScanDetails from '@/components/Actions/ScanDetails.vue'
import axios from 'axios'

export default {
    name: 'SearchHash',
    components: { 
        ScanDetails
    },
    data() {
            return {
                scanDetails: null,
                searchType: "find_by_md5",
                inputHash: "",
                // searchNotFound: false
            }
        },
    methods: {
        getSearchResults() {
            if (this.inputHash.length == 32) {
                axios.get(process.env.VUE_APP_BACK_URL + '/find_by_md5/' + this.inputHash.trim()).then((response) => {
                    this.scanDetails = response.data
                }).catch(() => {
                    console.log('error happened')
                });    
            } else if (this.inputHash.length == 40) {
                axios.get(process.env.VUE_APP_BACK_URL + '/find_by_sha1/' + this.inputHash.trim()).then((response) => {
                    this.scanDetails = response.data
                }).catch(() => {
                    console.log('error happened')
                });    
            } else if (this.inputHash.length == 64) {
                axios.get(process.env.VUE_APP_BACK_URL + '/find_by_sha256/' + this.inputHash.trim()).then((response) => {
                    this.scanDetails = response.data
                }).catch(() => {
                    console.log('error happened')
                });    
            }
            // this.searchNotFound = true;
            
        }
    }
}
</script>